module.exports = __webpack_public_path__ + "img/c96f66c.svg";